<template>
  <div>
    <nav class="navbar navbar-default navbar-fixed-top heasd">
      <div class="container-fluid">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collaplsed"
            data-toggle="collapse"
            data-target="#navigation"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="img-logo" style="cursor: pointer;">
            <img @click="goIndex" src="@/assets/logo4.png" alt="" />
          </div>
        </div>

        <div class="collapse navbar-collapse" id="navigation">
          <ul class="nav navbar-nav">
            <li
              class="link-wraper"
              :class="curpath == 'introduction' ? 'active' : ''"
            >
              <router-link to="/">{{ $t("About") }}</router-link>
            </li>
            <li
              class="link-wraper"
              :class="curpath == 'dynamics' ? 'active' : ''"
            >
              <router-link to="/dynamics">{{ $t("Events") }}</router-link>
            </li>
            <li
              class="link-wraper"
              :class="curpath == 'product' ? 'active' : ''"
            >
              <router-link to="/product">{{ $t("ProductsShow") }}</router-link>
            </li>
            <li
              class="link-wraper"
              :class="curpath == 'download' ? 'active' : ''"
            >
              <router-link to="/download">{{ $t("Material") }}</router-link>
            </li>
            <li class="logins">
              <template v-if="userInfo.id">
                <el-dropdown style="line-height: 32px" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <a href="javascript:void(0);" @click.prevent="login(1)">{{
                      userInfo.customerType == "1"
                        ? $t("Participantlogin2")
                        : $t("Participantlogin")
                    }}</a>
                  </span>
                  <el-dropdown-menu
                    slot="dropdown"
                    v-if="userInfo.customerType == '1'"
                    @click.stop
                  >
                    <el-dropdown-item command="curPer">{{
                      $t("personalcenter")
                    }}</el-dropdown-item>
                    <el-dropdown-item command="loginOut">{{
                      $t("loginOut")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <span style="font-size: 18px; color: #999999"
                  >&nbsp;/&nbsp;</span
                >
                <el-dropdown style="line-height: 32px" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <a href="javascript;;" @click.stop.prevent="login(2)">{{
                      userInfo.customerType == "2"
                        ? $t("Judgelogin2")
                        : $t("Judgelogin")
                    }}</a>
                  </span>
                  <el-dropdown-menu
                    slot="dropdown"
                    v-if="userInfo.customerType == '2'"
                    @click.stop
                  >
                    <el-dropdown-item command="curPer">{{
                      $t("personalcenter")
                    }}</el-dropdown-item>
                    <el-dropdown-item command="loginOut">{{
                      $t("loginOut")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>
                <a href="javascript;;" @click.prevent="login(1)">{{
                  $t("Participantlogin")
                }}</a>
                <span style="font-size: 18px; color: #999999"
                  >&nbsp;/&nbsp;</span
                >
                <a href="javascript;;" @click.prevent="login(2)">{{
                  $t("Judgelogin")
                }}</a>
              </template>

              <!-- <ul class="user-dropdown" v-if="userInfo.id">
                        <li>{{$t('personalcenter')}}</li>
                        <li @click="loginOut">退出登录</li>
                      </ul> -->
            </li>

            <!-- <el-tree
                :data="datas"
                :props="defaultProps"
                @node-click="handleNodeClick"
              ></el-tree> -->
            <li class="loginss link-wraper">
              <a href="javascript;;" @click.stop.prevent="login(1)">
                {{
                  userInfo.customerType == "1"
                    ? $t("Participantlogin2")
                    : $t("Participantlogin")
                }}
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a
                @click.stop.prevent="curPer"
                href="javascript;;"
                style="
                  padding-left: 2em;
                  padding-top: 0;
                  padding-bottom: 5px;
                  color: #6f73f4;
                "
                v-if="userInfo.customerType == '1'"
              >
                {{ $t("personalcenter") }}</a
              >
              <a
                @click.stop.prevent="loginOut"
                href="javascript;;"
                style="
                  padding-left: 2em;
                  padding-top: 5px;
                  padding-bottom: 10px;
                  color: #6f73f4;
                "
                v-if="userInfo.customerType == '1'"
              >
                {{ $t("loginOut") }}</a
              >
            </li>
            <li class="loginss link-wraper">
              <a href="javascript;;" @click.stop.prevent="login(2)">
                {{
                  userInfo.customerType == "2"
                    ? $t("Judgelogin2")
                    : $t("Judgelogin")
                }}
              </a>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a
                @click.stop.prevent="curPer"
                href="javascript;;"
                style="
                  padding-left: 2em;
                  padding-top: 0;
                  padding-bottom: 5px;
                  color: #6f73f4;
                "
                v-if="userInfo.customerType == '2'"
              >
                {{ $t("personalcenter") }}</a
              >
              <a
                @click.stop.prevent="loginOut"
                href="javascript;;"
                style="
                  padding-left: 2em;
                  padding-top: 5px;
                  padding-bottom: 10px;
                  color: #6f73f4;
                "
                v-if="userInfo.customerType == '2'"
              >
                {{ $t("loginOut") }}</a
              >
            </li>
            <li class="language">
              <div
                class="zh-btn pointer"
                @click="select('en')"
                :class="lang == 'zh' ? 'active' : ''"
              >
                中文
              </div>
              <span style="font-size: 14px; color: #e83d25">&nbsp;/&nbsp;</span>
              <div
                class="zh-btn pointer"
                @click="select('zh')"
                :class="lang == 'en' ? 'active' : ''"
              >
                ENG
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <el-carousel
      arrow="never"
      class="carouselcarousel"
      style="margin-top: 104px"
    >
      <el-carousel-item
        v-for="(item, index) in bannerList"
        :key="index"
        @change="setSize"
      >
        <div>
          <img class="swiper" :src="item.img" alt />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      PathList: [
        {
          path: "",
        },
      ],
      curpath: "",
      datas: [
        {
          label: "已登录参赛账号",
          children: [
            {
              label: "个人中心",
            },
            {
              label: "退出登录",
            },
          ],
        },
        {
          label: "评委登录",
          children: [
            {
              label: "个人中心",
            },
            {
              label: "退出登录",
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  watch: {
    $route: {
      //handler 方法就相当于普通侦听器触发的事件,即:当数据变化时要执行的操作
      handler: function (newV, oldV) {
        console.log("val.name", newV);
        this.curpath = newV.name;
      },
      immediate: true, //当监听的属性为一个对象的时候添加deep:true才可以起作用
    },
    lang: {
      handler: function (newV, oldV) {},
    },
  },
  methods: {
    goIndex(){
      this.$router.push("/")
      this.SETACTIVES(0);
      this.SETACTIVE(-1);
    },

    select(lang) {
      if (lang === "zh") {
        this.curLang = "en";
        this.$i18n.locale = "en";
        this.SETLANG("en");
        localStorage.setItem("lang", "en");
      } else {
        this.curLang = "zh";
        this.$i18n.locale = "zh";
        this.SETLANG("zh");
        localStorage.setItem("lang", "zh");
      }
      this.getBanner();
      this.reload();
    },
    loginOut() {
      this.SETUSERINFO({});
      this.$router.push("/");
      // localStorage.removeItem('userInfo')
    },
    curPer() {
      this.SETACTIVES(null);
      this.SETACTIVE(-1);
      this.$router.push("/user");
    },
    handleCommand(type) {
      if (type == "loginOut") {
        this.loginOut();
      }
      if (type == "curPer") {
        this.curPer();
      }
    },
    handleNodeClick() {},
    setSize() {},
    login(type) {
      console.log("typetypetype", type);
      if (+this.userInfo.customerType == type) return;

      if (this.userInfo.id) {
        
        this.$confirm(this.lang=='zh'?'确认切换账号吗？':'Are you sure to switch accounts?')
          .then((_) => {
             this.SETUSERINFO({});
      // 设置登录类型
      this.SETLOGINTYPE(type);
      this.SETACTIVES(null);
      this.SETACTIVE(7);
      console.log(this.activeIndex2, "type");
          })
          .catch((_) => {
            console.log("！！！");
          });
        return;
      }else{
        this.SETLOGINTYPE(type);
        this.SETACTIVES(null);
        this.SETACTIVE(7);
      }
     
    },
    getBanner() {
      this.$getHttp("pc/Banner/list", {
        language: 1,
      }).then((res) => {
        if (res.success) {
          console.log("res", res);
          res.list.map((item) => {
            item.img = this.$imgUrl + item.img;
          });

          this.SETBANNERLIST(res.list);
          console.log(this.bannerList);
        } else {
        }
      });
    },
  },
  created() {
    this.getBanner();
  },
};
</script>

<style lang='less' >
.popper__arrow {
  // border-bottom-color: red!important;
  // border-top-color: red!important;
  // border-left-color: #6f73f4 !important;
  // border-right-color: #6f73f4 !important;
  filter: drop-shadow(0 2px 12px rgba(111, 105, 248, 0.6)) !important;
  color: red;
  display: none !important;
}
.el-dropdown-menu {
  &.el-popper {
    padding: 0px 0;
    margin: 0px 0;
    border: 1px solid #6f73f4;

    .el-dropdown-menu__item {
      line-height: 48px;
      padding-left: 28px;
      padding-right: 28px;
      height: 48px;
      font-size: 18px;
      font-weight: 400;
      &:first-child {
        border-bottom: 1px solid #6f73f4;
      }
      &:last-child {
        border-top: 1px solid #6f73f4;
      }

      &:hover {
        background-color: #e8e8e8;
        color: #333333;
      }
    }
  }
}

.img-logo {
  height: 104px;
  display: flex;
  align-items: center;
  line-height: 104px;
  img {
    width: 150px;
  }
}
.carouselcarousel {
  .el-carousel__container {
    height: 0 !important;
    padding-bottom: 35.99%;
  }
}

.loginss {
  display: none !important;
  line-height: 0;
  .el-tree-node__content > .el-tree-node__label {
    font-size: 15px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #6f73f4;
  }

  .el-tree-node__children .el-tree-node__label {
    color: #333333 !important;
  }
}

.heasd {
  min-height: 104px;
  background: #ffffff !important;
  display: flex;
  align-items: center;
  .router-link-active {
    background-color: #ffffff !important;
  }
  .container-fluid {
    display: flex;
  }
  .navbar-nav {
    height: 104px;
    line-height: 104px;
    display: flex;
    li {
      display: flex;
      align-items: center;
      a {
        display: flex;
      align-items: center;
      height: 100%;
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .logins {
      position: relative;
      margin-right: 16px;
      margin-left: 8px;
      a {
        color: #6f73f4;
        text-decoration: none;
        &:hover {
          text-decoration: none;
        }
        &:focus {
          text-decoration: none;
        }
      }

      span {
        // line-height: 0;
      }
      .user-dropdown {
        position: absolute;
        bottom: -80px;
        left: 0;
        width: 162px;
        background: #ffffff;
        display: none;
        li {
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          border: 1px solid #6f73f4;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            background: #e8e8e8;
          }
        }
      }
      &:hover .user-dropdown {
        display: block;
      }
    }
  }
}

/deep/.el-carousel__container {
  position: relative;
  height: 0px;
  padding-bottom: 36.356%;
}
/deep/.el-carousel__indicators--horizontal {
  top: 0;
}
div {
  box-sizing: border-box;
}
.wrapper {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
.zh-btn {
  color: #999999;
  &.active {
    color: #6f73f4;
  }
}
a {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  line-height: 25px;

  &:hover {
    text-decoration: none;
  }
  &:focus {
    text-decoration: none;
  }
}
.link-wraper {
  &.active {
    a {
      color: #6f73f4;
      &::after {
      content: "";
      display: block;
      position: absolute;

      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 4px;
      background: #6f73f4;
      border-radius: 2px 2px 2px 2px;
      opacity: 1;
    }
    }
    
  }
}

.header-nav {
  height: 104px;
  position: relative;
  .header-nav-bg {
    //  width: 100px;
    // height: 100%;
    // background: purple;
    // transform: perspective(10px) rotateX(-5deg);
    // position: relative;
    // left: 26px;

    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    width: calc((100vw - 1200px) / 2 + 290px);
    // background-color: #6f73f4;
    &::after {
      // content: "";
      // display: block;
      // position: absolute;
      // top: 0;
      // right: 0;
      // border-left: 26px solid transparent;
      // border-right: 26px solid #fff;
      // border-top: 52px solid transparent;
      // border-bottom: 52px solid #fff;
      // width: 0;
      // height: 0;
    }
  }

  .img-logo {
    width: 216px;
    height: 100%;

    // line-height: 180px;
    &::after {
      // content: "";
      // display: inline-block;
      // height: 100%;
      // width: 0;
      // opacity: 0;
      // background-color: transparent;
    }
    img {
      vertical-align: middle;
    }
  }
  .router-link {
    height: 100%;
    line-height: 104px;
    .link-wraper {
      position: relative;

      margin-left: 60px;
      white-space: nowrap;
      height: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  // .el-carousel__container{
  //   // min-height: 200px !important;
  // padding-bottom: 48%;
  // }

  .heasd {
    display: block;
    .navbar-nav {
      display: block;
      height: auto;
    }
    .container-fluid {
      display: block;
    }
    .language {
      padding: 15px;
      line-height: 0;
    }

    .link-wraper.active[data-v-7af6b307]::after {
      opacity: 0;
    }
    .active {
      .router-link-active {
        background-color: #e7e7e7 !important;
      }
    }
  }
}

@media screen and (max-width: 1003px) {
  .img-logo {
    display: none;
  }
}

@media screen and (max-width: 1063px) {
  .heasd .navbar-nav li a {
    font-size: 15px;
  }
}

@media screen and (max-width: 768px) {
  .img-logo {
    display: block;
    text-align: center;
  }
  .logins {
    display: none !important;
  }

  .loginss {
    display: block !important;
  }
}
</style>